const appToastMsg = {
  /**
   *  상품 상세 미리보기 데이터 요청하기
   */
  GET_PRODUCT_PREVIEW_DATA_REQUEST_SUCCESS: '상품 상세 미리보기 데이터 요청하기 성공',
  GET_PRODUCT_PREVIEW_DATA_REQUEST_ERROR: '상품 상세 미리보기 데이터 요청하기 실패',

  /**
   *  태그 상세 미리보기 데이터 요청하기
   */
  GET_TAG_PREVIEW_DATA_REQUEST_SUCCESS: '태그 상세 미리보기 데이터 요청하기 성공',
  GET_TAG_PREVIEW_DATA_REQUEST_ERROR: '태그 상세 미리보기 데이터 요청하기 실패',

  /**
   *  주문 배송 조회 데이터 요청하기
   */
  GET_ORDER_DELIVERY_TRACKING_REQUEST_SUCCESS: '주문 배송 조회 데이터 요청하기 성공',
  GET_ORDER_DELIVERY_TRACKING_REQUEST_ERROR: '주문 배송 조회 데이터 요청하기 실패',

  /**
   *  배송지 변경 이력 조회 데이터 요청하기
   */
  GET_ORDER_DELIVERY_MODIFY_DATA_REQUEST_SUCCESS: ' 배송지 변경 이력 조회 데이터 요청하기 성공',
  GET_ORDER_DELIVERY_MODIFY_DATA_REQUEST_ERROR: ' 배송지 변경 이력 조회 데이터 요청하기 실패',

  /**
   *  기획전 아이템 리스트 요청하기
   */
  GET_EVENT_ITEM_LIST_REQUEST_SUCCESS: '기획전 아이템 리스트 요청하기 성공',
  GET_EVENT_ITEM_LIST_REQUEST_ERROR: '기획전 아이템 리스트 요청하기 실패',

  /**
   *  브랜드 상품 리스트 요청하기
   */
  GET_BRAND_PRODUCT_LIST_REQUEST_SUCCESS: '브랜드 상품 리스트 요청하기 성공',
  GET_BRAND_PRODUCT_LIST_REQUEST_ERROR: '브랜드 상품 리스트 요청하기 실패',

  /**
   *  상품 공지사항 아이템 리스트 요청하기
   */
  GET_NOTICE_PRODUCT_ITEM_LIST_REQUEST_SUCCESS: '상품 공지사항 아이템 리스트 요청하기 성공',
  GET_NOTICE_PRODUCT_ITEM_LIST_REQUEST_ERROR: '상품 공지사항 아이템 리스트 요청하기 실패',

  /**
   *  문자 발송 요청하기전 수신자 정보와 관리자 권한 체크하기
   */
  PREPARE_SEND_MESSAGE_SERVICE_REQUEST_SUCCESS: '문자 발송 준비하기 성공',
  PREPARE_SEND_MESSAGE_SERVICE_REQUEST_ERROR: '문자 발송 준비하기 실패',

  /**
   *  문자 발송 요청하기
   */
  SEND_MESSAGE_SERVICE_REQUEST_SUCCESS: '문자 발송 요청하기 성공',
  SEND_MESSAGE_SERVICE_REQUEST_ERROR: '문자 발송 요청하기 실패',

  /**
   *  이미지 임시 저장 요청하기
   */
  ADD_TEMP_IMG_REQUEST_SUCCESS: '이미지 임시 저장 성공',
  ADD_TEMP_IMG_REQUEST_ERROR: '이미지 임시 저장 실패',

  /**
   *  반품 요청, 반품 거부, 교환 요청, 교환 거부 이미지 가져오기
   */
  GET_REQUEST_REJECT_ATTACHMENT_DATA_REQUEST_ERROR: '반품 요청, 반품 거부, 교환 요청, 교환 거부 이미지 요청하기 실패',

  /**
   *  태그명 유효성 검사하기
   */
  CHECK_TAG_NAME_REQUEST_ERROR: '태그명 유효성 검사하기 실패',

  /**
   *  연관된 태그 리스트 요청하기
   */
  GET_RELATED_TAG_LIST_REQUEST_ERROR: '연관된 태그 리스트 요청하기 실패',

  /**
   * [쿠폰 발급] 쿠폰 발급 유효성 체크 요청하기
   */
  CHECK_VALID_GENERATE_COUPON_REQUEST_SUCCESS: '쿠폰 발급 유효성 체크 성공',
  CHECK_VALID_GENERATE_COUPON_REQUEST_ERROR: '쿠폰 발급 유효성 체크 실패',

  /**
   *  [쿠폰 발급] 발급할 쿠폰 리스트 가져오기
   */
  GET_ISSUED_COUPON_LIST_REQUEST_SUCCESS: '발급할 쿠폰 리스트 요청하기 성공',
  GET_ISSUED_COUPON_LIST_REQUEST_ERROR: '발급할 쿠폰 리스트 요청하기 실패',

  /**
   *  [쿠폰 발급] 쿠폰 발급 요청하기
   */
  GENERATE_COUPON_REQUEST_SUCCESS: '쿠폰 발급 요청하기 성공',
  GENERATE_COUPON_REQUEST_ERROR: '쿠폰 발급 요청하기 실패',

  /**
   * [포인트 발급] 포인트 발급 유효성 체크 요청하기
   */
  CHECK_VALID_GENERATE_POINT_REQUEST_SUCCESS: '포인트 발급 유효성 체크 성공',
  CHECK_VALID_GENERATE_POINT_REQUEST_ERROR: '포인트 발급 유효성 체크 실패',

  /**
   * [포인트 발급 모달] 포인트 발급 하기
   */
  GENERATE_POINT_REQUEST_SUCCESS: '포인트 발급 성공',
  GENERATE_POINT_REQUEST_ERROR: '포인트 발급 실패',

  /**
   *  상품 2차 카테고리 리스트 가져오기
   */
  GET_PRODUCT_SUB_CATEGORY_LIST_REQUEST_ERROR: '2차 카테고리 리스트 요청하기 실패',

  /**
   *  구매자 이전 구매내역 조회 데이터 요청하기
   */
  GET_BUYER_PURCHASE_HISTORY_REQUEST_ERROR: '구매자 이전 구매내역 요청하기 실패',

  /**
   *  아이템 검색 리스트 요청하기
   */
  GET_PRODUCT_CATEGORY_SEARCH_LIST_REQUEST_SUCCESS: '상품 카테고리 검색 리스트 요청하기 성공',
  GET_PRODUCT_CATEGORY_SEARCH_LIST_REQUEST_ERROR: '상품 카테고리 검색 리스트 요청하기 실패',
};

export default appToastMsg;
